import i18next from 'i18next'
import { I18nextProvider } from 'react-i18next'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import commonFr from '@translation/fr/common'
import formFr from '@translation/fr/form'
import missionFr from '@translation/fr/mission'
import userFr from '@translation/fr/user'
import securityFr from '@translation/fr/security'
import sterilizationFr from '@translation/fr/sterilization'
import permissionsFr from '@translation/fr/permissions'
import errorsFr from '@translation/fr/errors'
import missionPreparationFr from '@translation/fr/mission-preparation'
import commonEn from '@translation/en/common'
import formEn from '@translation/en/form'
import missionEn from '@translation/en/mission'
import userEn from '@translation/en/user'
import securityEn from '@translation/en/security'
import sterilizationEn from '@translation/en/sterilization'
import permissionsEn from '@translation/en/permissions'
import errorsEn from '@translation/en/errors'
import missionPreparationEn from '@translation/en/mission-preparation'
import commonEs from '@translation/es/common'
import formEs from '@translation/es/form'
import missionEs from '@translation/es/mission'
import userEs from '@translation/es/user'
import securityEs from '@translation/es/security'
import sterilizationEs from '@translation/es/sterilization'
import permissionsEs from '@translation/es/permissions'
import errorsEs from '@translation/es/errors'
import missionPreparationEs from '@translation/es/mission-preparation'
import EngineRouter from '@router/EngineRouter'
import { Provider } from 'react-redux'
import { store } from '@store/store'

if (!window.localStorage.getItem('local')) {
  const browserLanguage = navigator.language.split('-')[0]
  const defaultLanguage = false !== ['fr', 'en', 'es'].indexOf(browserLanguage) ? browserLanguage : 'fr'
  window.localStorage.setItem('local', defaultLanguage)
}

i18next.init({
  interpolation: { escapeValue: false },
  lng: window.localStorage.getItem('local') || 'fr',
  resources: {
    fr: {
      common: commonFr,
      user: userFr,
      security: securityFr,
      errors: errorsFr,
      mission: missionFr,
      form: formFr,
      sterilization: sterilizationFr,
      permissions: permissionsFr,
      missionPreparation: missionPreparationFr
    },
    en: {
      common: commonEn,
      user: userEn,
      security: securityEn,
      errors: errorsEn,
      mission: missionEn,
      form: formEn,
      sterilization: sterilizationEn,
      permissions: permissionsEn,
      missionPreparation: missionPreparationEn
    },
    es: {
      common: commonEs,
      user: userEs,
      security: securityEs,
      errors: errorsEs,
      mission: missionEs,
      form: formEs,
      sterilization: sterilizationEs,
      permissions: permissionsEs,
      missionPreparation: missionPreparationEs
    }
  }
})

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <RouterProvider router={EngineRouter()} />
      </Provider>
    </I18nextProvider>
  </StrictMode>,
)
